import MasterSerive from "./MasterService";

const InsuranceService = {
    ...MasterSerive,

    getFormConfig() {
        return this.get('/agency/api/formconfig')
    },
    getMasterConfig() {
        return this.get('agency/api/masterConfig')
    },

    getAddonList(params: object) {
        return this.post('agency/api/getAddOn', params)
    },

    getLeadList(params: object) {
        return this.post('agency/api/leadList', params)
    },

    getClaimList(params: object) {
        return this.post('agency/api/claimList', params)
    },

    RaiseClaim(params: object) {
        return this.post('agency/api/raiseClaim', params)
    },
    bulkPayment(params: object) {
        return this.post('agency/api/bulkPayment', params)
    },
    paymentProofDocs(params: object) {
        return this.post('/payment/paymentProofDocs', params) 
    },
    getLeadPaymentDetails(params: object) {
        return this.post('agency/api/getLeadPaymentDetails', params) 
    },
    getQuoteDetail(params: object) {
        return this.post('agency/api/leadQuoteDetails', params) 
    },

    getPartnerList(params: any) {
        return this.post('/agency/api/getPartner', params)
    },

    getAddonDetails(params: any) {
        return this.post('/agency/api/getAddonDetails', params)
    },

    createAgencyLead(params: any) {
        return this.post('/agency/api/createAgencyLead', params)
    },
    raisedSoa(params: object) {
        return this.post('agency/api/raiseSoa', params) 
    },
    getPartnerInfo(){
        return this.get('/agency/api/insurancePartnerInfo');
    },
    getLeadDetails(params: any) {
        return this.post('/lead/leadDetails', params)
    },
    fetchAllDocuments(params: any) {
        return this.post('/lead/fetchAllDocuments', params)
    },
    updateDocStatus(params: any) {
        return this.post('/lead/updateDocStatus', params)
    },
    downloadAllPolicies(params: object) {
        return this.post('agency/api/downloadPolicy', params) 
    },
    generateDocUrls(params: object) {
        return this.post('agency/api/uploadLeadDocImages', params) 
    },
    getMappingAgencyList(params: object) {
        return this.post('/agencySalesUser/getMappingAgencyList', params) 
    },
    loginAgency(params: object){
      return this.post('/agency/auth/loginAgency', params)  
    },
    getStateList() {
        return this.post('/common/getStateList', {})
    },
    getCityList(params: { state: any[] }) {
        return this.post('/common/getCityList', params)
    },
    getLocalityList(params: { city: any[] }) {
        return this.post('/common/getLocalityList', params)
    }

}

export default InsuranceService;
